import { render, staticRenderFns } from "./AddPaqueteFoliosModal.vue?vue&type=template&id=15a534da"
import script from "./AddPaqueteFoliosModal.vue?vue&type=script&lang=js"
export * from "./AddPaqueteFoliosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a534da')) {
      api.createRecord('15a534da', component.options)
    } else {
      api.reload('15a534da', component.options)
    }
    module.hot.accept("./AddPaqueteFoliosModal.vue?vue&type=template&id=15a534da", function () {
      api.rerender('15a534da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/AddPaqueteFoliosModal.vue"
export default component.exports